import { ActionType } from './action';

function geeksJokeReducer(geeksJoke = null, action = {}) {
  switch (action.type) {
    case ActionType.RECEIVE_GEEKSJOKE:
      return action.payload.geeksJoke;
    default:
      return geeksJoke;
  }
}

export default geeksJokeReducer;
